/* global translations */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import {
  ExtendedFormQuestion,
  ExtendedFormAttachments,
  ExtendedFormEmail,
  ExtendedFormSubmitError,
  ExtendedFormSubmitSuccess,
} from '../../components/suggestions';
import { ImageSvg } from '../../components/image';
import SuggestionsExtendedStore from '../../stores/SuggestionsExtendedStore';

class ExtendedFormContainer extends Component {
  state = {
    questions: [],
    showErrors: false,
  };

  componentDidMount() {
    SuggestionsExtendedStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    SuggestionsExtendedStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      questions: SuggestionsExtendedStore.getQuestions(),
      showErrors: SuggestionsExtendedStore.getShowErrors(),
    });
  };

  updateFormData = (data) => {
    SuggestionsExtendedStore.updateFormData(data);
    SuggestionsExtendedStore.updatedQuestionsWithLinked();
    SuggestionsExtendedStore.setSubmitStatus(null);

    const { showErrors } = this.state;
    if (!showErrors) {
      SuggestionsExtendedStore.emitChange();
      return;
    }

    const emptyAnswers = SuggestionsExtendedStore.getFormDataEmptyAnswers();
    SuggestionsExtendedStore.updateEmptyAnswersErrors(emptyAnswers);
    SuggestionsExtendedStore.emitChange();
  };

  render() {
    const { questions, showErrors } = this.state;
    const { onSubmit, submitStatus } = this.props;

    if (!questions.length) {
      return (null);
    }

    if (submitStatus === 'success') {
      return (<ExtendedFormSubmitSuccess />);
    }

    return (
      <form onSubmit={onSubmit} className="paxl pts tal bb">
        {questions.map((item) => (
          <ExtendedFormQuestion
            key={item.id}
            id={item.id}
            title={item.title}
            type={item.type}
            answers={item.answers}
            onChange={this.updateFormData}
            errorMsg={showErrors ? (item.error || '') : ''}
          />
        ))}
        <ExtendedFormAttachments />
        <ExtendedFormEmail />
        <div className="tar">
          {submitStatus === 'error' && (
            <ExtendedFormSubmitError />
          )}
          <button
            type="submit"
            className={`btn btn--a btn--small btn--iconLeft mtm${submitStatus === 'loading' ? ' has-loader' : ''}`}
          >
            <span className="btn-text">{get(translations, 'txt: Nosūtīt', 'txt: Nosūtīt')}</span>
            <span className="btn-static">
              <ImageSvg svg="icon-plane" iconClass="icon--center icon--plane" />
            </span>
          </button>
        </div>
        <div className="mtl mlxs tsi">
          {get(translations, 'txt: Ņem vērā, ka administrācija izskata ziņojumus darba laikā: Pirmdiena - Piektdiena 9:00-17:00', '')}
        </div>
      </form>
    );
  }
}

ExtendedFormContainer.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitStatus: PropTypes.string,
};

ExtendedFormContainer.defaultProps = {
  submitStatus: null,
};

export default ExtendedFormContainer;
